import React from 'react';
import { Button } from 'primereact/button';
import GenericFileExportButton from '../../../components/common/GenericFileExportButton';
import { useLanguage } from '../../../contexts/LanguageContext';
import { useLazyExportBulletinImplementationReportToExcelQuery } from '../../../api/endpoints/bulletinImplementationReport';
import BulletinImplementationReportTable from './component/BulletinImplementationReportTable';
import useBulletinImplementationReportData from './hook/useBulletinImplementationReportData';

const BulletinImplementationReportPage = () => {
    const { th } = useLanguage();
    const report = useBulletinImplementationReportData();
    return (
        <div className="card">
            <div className="flex justify-content-between align-items-center mb-4">
                <h1 className="m-0">{th('bulletinImplementationReport.title')}</h1>
                <div className="flex gap-2">
                    <Button icon="pi pi-filter-slash" className="p-button-outlined p-button-secondary" onClick={report.reset} tooltip={th('filter.reset')} tooltipOptions={{ position: 'left' }} />
                    <GenericFileExportButton
                        useExportQuery={useLazyExportBulletinImplementationReportToExcelQuery}
                        exportParams={report.exportParams}
                        buttonLabel="Excel"
                        buttonClassName="p-button-success"
                        icon="pi pi-file-excel"
                        fileNameExtractor={(result) => result?.fileName || 'Bülten Uygulanma Durumu.xlsx'}
                        dataExtractor={(result) => result?.fileBase64}
                        contentTypeExtractor={(result) => result?.contentType}
                    />
                </div>
            </div>
            <BulletinImplementationReportTable
                items={report.data?.items ?? []}
                totalCount={report.data?.totalCount ?? 0}
                loading={report.isLoading}
                lazyParams={report.lazyParams}
                activeFilters={report.activeFilters}
                onFiltersChange={report.onFiltersChange}
                sortField={report.sortField}
                sortOrder={report.sortOrder}
                onPage={report.onPage}
                onSort={report.onSort}
            />
        </div>
    );
};
export default BulletinImplementationReportPage;
